import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { IconButton } from '@material-ui/core';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import RenderMoreAction from './FormItemMoreAction';
import { onChangeActiveForm } from './handler/FormListHandler';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function FormListItem({ item, argsAll }) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();

    let definitionName = item.definitionName;
    if (!definitionName && item.affiliationOrganization) {
        let corporationInfo = argsAll.allListCorp.find(
            corp => corp.id === item.affiliationOrganization
        );
        if (!Utils.isEmptyObject(corporationInfo)) {
            definitionName =
                corporationInfo?.active === Constant.CORPORATION_ACTIVE.BLOCK
                    ? `${corporationInfo.title}(${tr('停止中')})`
                    : corporationInfo.title;
        }
    }

    const isDisplayIconPin = () => {
        if (
            Utils.isSystemAIAutoForm(item) ||
            Utils.isSystemFormChatAIPrompt(item) ||
            Utils.isSystemSDAutoForm(item) ||
            Utils.isSystemFormAITelephonePrompt(item) ||
            Utils.isSystemFormAIAssistantPrompt(item) ||
            Utils.isSystemFormAITrainingPrompt(item) ||
            Utils.isSystemFormKBoardPrompt(item) ||
            Utils.isSystemKBoardKnowledgeForm(item)
        ) {
            return false;
        }
        
        if (Utils.isSystemTelephoneForm(item)) return true;
        return (
            item.isProjectInuse &&
            item.definition === Constant.FORM_DEFINITION.SYSTEM &&
            [
                Constant.FORM_TYPE.FILE_FORMAT,
                Constant.FORM_TYPE.PAGE_FORMAT,
                Constant.FORM_TYPE.EMAIL_FORMAT,
                Constant.FORM_TYPE.FORM_KNOWLEDGE,
            ].includes(item.type) &&
            item.type !== Constant.FORM_TYPE.FORM_REQ_QA
        );
    };

    const isSystemFormFilePageFormat = () => {
        if (
            Utils.isSystemAIAutoForm(item) ||
            Utils.isSystemFormChatAIPrompt(item) ||
            Utils.isSystemSDAutoForm(item) ||
            Utils.isSystemFormAITelephonePrompt(item) ||
            Utils.isSystemFormAIAssistantPrompt(item) ||
            Utils.isSystemFormAITrainingPrompt(item) ||
            Utils.isSystemFormKBoardPrompt(item) || 
            Utils.isSystemKBoardKnowledgeForm(item)
        )
            return false;
        if (Utils.isSystemTelephoneForm(item)) return true;
        return (
            item.definition === Constant.FORM_DEFINITION.SYSTEM &&
            [
                Constant.FORM_TYPE.FILE_FORMAT,
                Constant.FORM_TYPE.PAGE_FORMAT,
                Constant.FORM_TYPE.EMAIL_FORMAT,
                Constant.FORM_TYPE.FORM_KNOWLEDGE,
            ].includes(item.type)
        );
    };

    return (
        <>
            <div className="listManage-icon">
                {(item.type === Constant.FORM_TYPE.FORM_KNOWLEDGE ||
                    item.type === Constant.FORM_TYPE.FORM_MASTER) &&
                    item.reviewFlag && (
                        <div>
                            <img src="/assets/image/icon-review-flag-on.png" alt="" />
                        </div>
                    )}
                {(item.type === Constant.FORM_TYPE.FORM_KNOWLEDGE ||
                    item.type === Constant.FORM_TYPE.FORM_MASTER) &&
                    !item.reviewFlag && (
                        <div>
                            <img src="/assets/image/icon-review-flag-off.png" alt="" />
                        </div>
                    )}
                {(item.type === Constant.FORM_TYPE.FORM_KNOWLEDGE ||
                    item.type === Constant.FORM_TYPE.FORM_MASTER) && (
                    <div className="listManage-knowledge">
                        <img
                            src={
                                item.type === Constant.FORM_TYPE.FORM_MASTER
                                    ? '/assets/image/icon-master-knowledge.png'
                                    : '/assets/image/icon-knowledge.png'
                            }
                            alt=""
                        />
                    </div>
                )}
            </div>

            <div className="listManage-wrap-info">
                <div className="listManage-title">
                    <OverFlowTooltipWithTabsMui
                        value={trLabel(Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name))}
                    >
                        <p>{trLabel(Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name))}</p>
                    </OverFlowTooltipWithTabsMui>
                </div>
                <div className="listManage-info">
                    <OverFlowTooltipWithTabsMui value={definitionName === Constant.FORM_DEFINITION_NAME.SYSTEM ? tr(Constant.FORM_DEFINITION_NAME.SYSTEM) : definitionName}>
                        <div className="listManage-project">{definitionName === Constant.FORM_DEFINITION_NAME.SYSTEM ? tr(Constant.FORM_DEFINITION_NAME.SYSTEM) : definitionName}</div>
                    </OverFlowTooltipWithTabsMui>
                    <div
                        className={
                            !isSystemFormFilePageFormat() ? 'listManage-tools' : 'listManage-tools d-none'
                        }
                    >
                        <div className="listManage-item">
                            {item.isProjectInuse && !isDisplayIconPin() && (
                                <IconButton
                                    onClick={() => onChangeActiveForm(false, item.id, argsAll)}
                                    className="itemTools"
                                >
                                    <img src="/assets/image/icon-pin.svg" alt="" />
                                </IconButton>
                            )}
                            {!item.isProjectInuse && (
                                <IconButton
                                    onClick={() => onChangeActiveForm(true, item.id, argsAll)}
                                    className="itemTools"
                                >
                                    <img src="/assets/image/icon-pin-outline.svg" alt="" />
                                </IconButton>
                            )}
                        </div>
                        {item.definition !== Constant.FORM_DEFINITION.SYSTEM && (
                            <RenderMoreAction
                                key={`render-more-action-${item.id}`}
                                item={item}
                                projectInuseDetail={argsAll.projectInuseDetail}
                                argsAll={argsAll}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
